import { Globe2, Search, Upload, UserPlus, UserX } from "lucide-react";

const ORIGINS = {
  embed_form: { label: "Website Form", icon: Globe2, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  search: { label: "Prospect Search", icon: Search, cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  csv_import: { label: "CSV Import", icon: Upload, cls: "bg-amber-50 text-amber-700 border-amber-200" },
  manual: { label: "Added Manually", icon: UserPlus, cls: "bg-slate-50 text-slate-600 border-slate-200" },
};

const initials = (name) => (name || "?").split(/\s+/).map((p) => p[0]).slice(0, 2).join("").toUpperCase();

export const LeadMetaRow = ({ company }) => {
  const origin = ORIGINS[company.lead_origin] || ORIGINS.manual;
  const Icon = origin.icon;
  const showAdder = company.lead_origin !== "embed_form" && company.added_by_name;
  return (
    <div data-testid={`lead-meta-${company.company_id}`} className="px-3 py-2 border-t border-slate-100 flex items-center justify-between gap-2 text-[10px]">
      <span
        data-testid={`lead-origin-${company.company_id}`}
        title={showAdder ? `${origin.label} · added by ${company.added_by_name}` : origin.label}
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-medium truncate ${origin.cls}`}>
        <Icon className="w-2.5 h-2.5 shrink-0" />
        <span className="truncate">{origin.label}{showAdder ? ` · ${company.added_by_name.split(" ")[0]}` : ""}</span>
      </span>
      {company.owner_name ? (
        <span data-testid={`lead-owner-${company.company_id}`} className="inline-flex items-center gap-1.5 min-w-0 text-slate-600" title={`Assigned to ${company.owner_name}`}>
          {company.owner_picture ? (
            <img src={company.owner_picture} alt="" referrerPolicy="no-referrer" className="w-4 h-4 rounded-full object-cover shrink-0" />
          ) : (
            <span className="w-4 h-4 rounded-full bg-[#4E3C97] text-white text-[7px] font-bold flex items-center justify-center shrink-0">{initials(company.owner_name)}</span>
          )}
          <span className="truncate font-medium">{company.owner_name}</span>
        </span>
      ) : (
        <span data-testid={`lead-owner-${company.company_id}`} className="inline-flex items-center gap-1 text-rose-600 font-medium">
          <UserX className="w-3 h-3" /> Unassigned
        </span>
      )}
    </div>
  );
};
